// extracted by mini-css-extract-plugin
export default {"Timesheet":"fNp6d","skeleton-progress":"xEqAk"};